angular.module('cvsApp').service('getSpecialtyOrderQuestionsService',['networkService', 'xdrService', 'getSpecialtyOrderQuestionsModel', 'configManager', function (NS, XS, GSOQM, CM) {
   	
	function getSpecialtyOrderQuestionsService (){	
		this.getQues = function(callBackSuccess,tokenId){
			//get url 
			var tid = tokenId || cvsUtility.queryMap.tokenId;
			var apiKey = cvsUtility.queryMap.apikey;
			var tokenType = (tokenId) ? 'Guest' : 'Login';
			var url;
			if (tid == '' || tid == undefined) {
				url = CM.getContentUrl('GET_ORDER_QUESTIONS');
			}
			else {
				url = CM.getApiUrl('GET_ORDER_QUESTIONS', tid, tokenType);
			}

			url = cvsUtility.updateQueryParam(url, 'version', '2.0');
			url = url + '&apiKey='+apiKey+'&tokenID='+tid+'&tokenType=Login';
			//url = 'https://devservices.caremark.com:448/specialty/getSpecialtyOrderQuestions?serviceName=getSpecialtyOrderQuestions&version=2.0&appName=SPL_WEB&lineOfBusiness=Specialty&channelName=Web&serviceCors=True&apiKey=d489fa90-8423-4db8-a11f-ff8f29ebdb19&tokenID=440B5940B29337438BEB6A716230096E&tokenType=Login';
			//url = cvsUtility.updateQueryParam(url, 'tokenID', tid);
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{},
							data:getRequestBody(tokenId),
							onSuccess:callBackSuccess
						}
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, getRequestBody(tokenId), xdrSuccess);

					function xdrSuccess (data) {
						GSOQM.setResponse(data);
						callBackSuccess(GSOQM.getResponse());
					}
				}
				else {
					var quesPromise = NS.post(request);	
					quesPromise.then(function(data, c, d){

						GSOQM.setResponse(data.data);
						callBackSuccess(GSOQM.getResponse());

						//send message to parent					
						//cvsUtility.sendPostMessage("SESSION-ALIVE","getSpecialtyOrderQuestions");
						
					}, function(reason){
						callBackSuccess(NS.httpError(reason));
					});					
				}		
			}
							
		}

		var getRequestBody = function(){
			return {};
		}
	}
	
	return new getSpecialtyOrderQuestionsService();	
}]);
